import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';

import { PipedriveWebformSectionCms } from '~/cms/interfaces/homepage.cms.interface';
import { CustomHeadTagService } from '~/core/services/custom-head-tag/custom-head-tag.service';

@Component({
  selector: 'app-cms-pipedrive-webform-section',
  templateUrl: './pipedrive-webform.component.html',
  styleUrls: ['./pipedrive-webform.component.scss'],
  // Need to change the width of the `iframe` inside loaded Pipedrive Web Form
  encapsulation: ViewEncapsulation.None,
})
export class CmsPipedriveWebformComponent implements OnInit, OnDestroy {
  @Input() public section: PipedriveWebformSectionCms;

  private readonly scriptId = 'webform-external-script';

  constructor(private readonly customHeadTagService: CustomHeadTagService) {}

  public ngOnDestroy(): void {
    this.customHeadTagService.removeTag(this.scriptId);
  }

  public ngOnInit(): void {
    // Pipedrive Web Forms need to load an external script to works
    this.customHeadTagService.addTag('script', {
      defer: '',
      id: this.scriptId,
      src: 'https://webforms.pipedrive.com/f/loader',
    });
  }
}
